export const creatureDrive = [
  "Territory Control",
  "Predation",
  "Destruction",
  "Parasitisation",
];
